document.addEventListener('DOMContentLoaded', () => {
  
  const originalButton = document.querySelector('.product-form__submit');
  const productForm = originalButton.closest('form');
  const main = document.querySelector('#main');

  const clonedButton = originalButton.cloneNode(true);
  clonedButton.classList.add('sticky-atc');

  const wrapper = document.createElement('div');
  wrapper.className = 'sticky-atc-wrapper';
  wrapper.appendChild(clonedButton);
  main.appendChild(wrapper);

  let isVisible = false;
  let hideTimeout;

  function checkScroll() {
    const formBottom = productForm.getBoundingClientRect().bottom;
    const mainBottom = main.getBoundingClientRect().bottom;
    const viewportHeight = window.innerHeight;
    const offset = 100;

    const shouldShow = formBottom < -offset && mainBottom > viewportHeight;

    if (shouldShow && !isVisible) {
      clearTimeout(hideTimeout);
      wrapper.style.visibility = 'visible';
      wrapper.classList.add('visible');
      isVisible = true;
    } else if (!shouldShow && isVisible) {
      wrapper.classList.remove('visible');
      hideTimeout = setTimeout(() => {
        wrapper.style.visibility = 'hidden';
      }, 300);
      isVisible = false;
    }
  }

  window.addEventListener('scroll', checkScroll);
  window.addEventListener('resize', checkScroll);

  document.addEventListener('click', (event) => {
    if (
      event.target.closest('.product-form__submit') ||
      event.target.closest('.sticky-atc')
    ) {
      const realForm = document.querySelector('form[data-type="add-to-cart-form"]');
      realForm.requestSubmit();
    }
  });

});


/* Accordion Magic ✨ */
document.addEventListener("DOMContentLoaded", () => {
  const accordionButtons = document.querySelectorAll(".accordion-btn");

  accordionButtons.forEach((btn) => {
    const accordionList = btn.nextElementSibling;

    btn.addEventListener("click", () => {
      const expanded = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", !expanded);

      if (!expanded) {
        accordionList.style.maxHeight = accordionList.scrollHeight + "px";
        accordionList.classList.add("open");
      } else {
        accordionList.style.maxHeight = 0;
        accordionList.classList.remove("open");
      }
    });
  });
});